import { STOModel } from "src/models/base/sto-model";
import { AnomalyTrackingDTO } from "../../models/tna/tna-anomalies/anomaly-tracking-dto";
import { BaseApiService } from "../base/base-api.service";

export class AnomaliesTrackingByEmployees extends BaseApiService<AnomalyTrackingDTO, STOModel> {
  constructor() {
    super({
      servicePath: "/Anomaly",
      loadItemsPath: "/GetAnomaliesTrackingByEmployees",
    });
  }
}
